import { AccordionBlockData } from 'api/cms';
import { AccordionBlock } from 'cms/blocks/Accordion/AccordionBlock';
import { BlockMapping } from 'cms/blocks/BlockMapping';

import { AmpAccordionBlock } from './AmpAccordionBlock';

export const AccordionBlockMapping: BlockMapping<AccordionBlockData> = {
  invariant: [
    {
      prop: 'sections',
      msg: 'Sections required for accordion',
    },
  ],
  width: 'INSET',
  Component: AccordionBlock,
  AmpComponent: AmpAccordionBlock,
};
